<template>
  <BlockUI>
    <h5 class='title'>{{title}}</h5>
    <slot name="body"></slot>
  </BlockUI>
</template>

<script>
export default {
    name: 'BlockerHelper',
    props: ['title'],
};
</script>

<style scoped>
  .title {
      font-weight: bold;
  }
</style>